/** ให้ตรงกับ backend internal/menu SalesDashboardGroups (ลำดับแถวดาต้าในกราฟ) */
export const SALES_GROUP_CHART_ORDER = ['กาแฟ', 'ชา', 'น้ำหวาน', 'ขนม', 'อื่นๆ'] as const;

export type SalesChartGroup = (typeof SALES_GROUP_CHART_ORDER)[number];

export function normalizeSalesByGroup(raw?: Record<string, number | string>): Record<SalesChartGroup, number> {
  const order = SALES_GROUP_CHART_ORDER;
  const o = {} as Record<SalesChartGroup, number>;
  for (const k of order) o[k] = 0;
  if (!raw) return o;
  const known = new Set<string>(order);
  for (const [key, val] of Object.entries(raw)) {
    const n = Number(val) || 0;
    if (known.has(key)) {
      o[key as SalesChartGroup] = n;
    } else {
      o['อื่นๆ'] += n;
    }
  }
  return o;
}
